import * as React from 'react'

import { Alert, Button, TextBody } from '@ally/metronome-ui'
import { LinkingSuccessProps } from '@ally/transmitigator'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { AccountDetails, StyledTextBody } from '../Shared'
import { getDisplayRole } from '../../Utils'
import { useHostServices } from '../../HostServices'

const LinkingSuccessContent: React.FC<LinkingSuccessProps> = ({
  onComplete,
  status,
  username,
  userData,
  userRelationships,
  error,
}) => {
  const handleContinue = (): void => {
    onComplete()
  }
  const { analytics } = useHostServices()

  React.useEffect(() => {
    analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Accounts Linked Successfully',
    })
  }, [])

  return (
    <>
      <LoginHeading title="You’re linked." />

      <Alert
        mb="sm"
        variant="success"
        disableContainer
        heading={
          <TextBody size="sm" tag="b" weight="bold">
            Your {getDisplayRole(userRelationships)} and Auto accounts are now
            linked.
          </TextBody>
        }
      />

      <StyledTextBody size="sm" tag="p">
        Log in, manage your accounts, and check out everything in one Snapshot
        with the username shown here. You can edit this info in your Profile.
      </StyledTextBody>

      <AccountDetails username={username} userData={userData} />

      <Button
        allytmln="Continue"
        loading={status === 'Loading'}
        onClick={handleContinue}
        text="Continue"
        type="submit"
        variant="primary"
      />
    </>
  )
}

export const LinkingSuccess: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'LinkingSuccess') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <LinkingSuccessContent {...activeScreen.payload} />
}
